import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function DunesDirtReport() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with Title */}
      <div className="relative h-[400px] md:h-[500px] mt-16 md:mt-24">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(a1.jpg)',
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <div className="absolute inset-0 flex items-center justify-center px-4">
            <h1 className="text-5xl md:text-8xl font-black text-white uppercase italic tracking-wider text-center leading-tight">
              Dirt Report
            </h1>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-8 uppercase italic tracking-widest">
            This Week at Throttle Edge
          </h2>
          
          <p className="text-center text-sm mb-8 md:mb-12 font-bold">Updated: Monday, December 8th</p>

          {/* Operating Hours Tuesday - Friday */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Operating Hours: Tuesday - Friday</h3>
            <p className="mb-2 text-sm md:text-base"><span className="font-semibold">Pro Shop:</span> 9:00 AM - 5:30 PM</p>
            <p className="mb-2 text-sm md:text-base"><span className="font-semibold">Riding Hours:</span> ALL TRACKS & TRAILS ARE NOW CLOSED FOR THE 2025 SEASON</p>
            <p className="italic text-xs md:text-sm">Closed on Mondays</p>
          </div>

          {/* Operating Hours Saturday */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Operating Hours: Saturday</h3>
            <p className="mb-2 text-sm md:text-base"><span className="font-semibold">Pro Shop:</span> 9:00 AM - 5:30 PM</p>
            <p className="mb-2 text-sm md:text-base"><span className="font-semibold">Riding Hours:</span> ALL TRACKS & TRAILS ARE NOW CLOSED FOR THE 2025 SEASON</p>
            <p className="italic text-xs md:text-sm">Closed on Sundays</p>
          </div>

          {/* Track Status */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Track Status:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm md:text-base">
              <li><span className="font-bold italic">Main Track:</span> CLOSED</li>
              <li><span className="font-bold italic">GP Track:</span> CLOSED</li>
              <li><span className="font-bold italic">Peewee Track:</span> CLOSED</li>
              <li><span className="font-bold italic">Beginner Track:</span> CLOSED</li>
            </ul>
          </div>

          {/* Trail Status */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Trail Status:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm md:text-base">
              <li><span className="font-bold italic">Trail 1:</span> CLOSED</li>
              <li><span className="font-bold italic">Trail 2:</span> CLOSED</li>
              <li><span className="font-bold italic">Trail 3:</span> CLOSED</li>
            </ul>
          </div>

          {/* Closures and Special Notes */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Closures and Special Notes:</h3>
            <p className="font-semibold text-sm md:text-base">ALL TRACKS & TRAILS ARE NOW CLOSED FOR THE 2025 SEASON</p>
          </div>

          {/* What's On This Week */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">What's On This Week:</h3>
            <p className="text-sm md:text-base">12 Days of Christmas: New deal unlocked everyday for 12 days (Sales end December 25th)</p>
          </div>

          {/* Food Vendors */}
          <div className="mb-6 md:mb-8">
            <h3 className="text-base md:text-lg font-bold mb-3 uppercase">Food Vendors:</h3>
            <p className="text-sm md:text-base">There will be no more food vendors on weekends for the remainder of the season</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DunesDirtReport;
